import React from 'react';
type LegalPageProps = {
  title: string;
};
export function LegalPage({
  title
}: LegalPageProps) {
  return <main className="min-h-[70vh] bg-black px-4 pb-20 pt-32 sm:px-6 md:pb-28 md:pt-40" data-id="element-56" data-mp="3rdnd0qoivjgk">
      <article className="mx-auto max-w-[720px]" data-id="element-57" data-mp="9790mw5wjhka">
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.3em] text-gold" data-id="element-58" data-mp="94w85p2iposz">
          Vantix Credit Solutions
        </p>
        <h1 className="mb-8 text-4xl font-semibold leading-tight text-white md:text-5xl" data-id="element-59" data-mp="i75iadtvjg5u">
          {title}
        </h1>
        <div className="border-t border-white/10 pt-8" data-id="element-60" data-mp="e50sjq6jr3oh">
          <p className="text-base leading-relaxed text-white/80 md:text-lg" data-id="element-61" data-mp="rxgyozuqvhtm">
            Contenido en preparación
          </p>
        </div>
      </article>
    </main>;
}